module.exports = __webpack_public_path__ + "static/circle_tag_stores-b0f0f9516e90367c2c33c2790ff4e143.png";